import actionTypes from '../../utilities/actionTypes';

// Action Definition
export interface IFetchScreens {
  type: actionTypes.FETCH_SCREENS;
  userId: string;
}

export interface IFetchScreenSuccess {
  type: actionTypes.FETCH_SCREENS_SUCCESS;
  payload: any;
}

export interface IFetchScreenPending {
  type: actionTypes.FETCH_SCREENS_PENDING;
}
export interface IDeleteScreen {
  type: actionTypes.DELETE_SCREEN;
  screenId: string;
}

export interface IDeleteScreenSuccess {
  type: actionTypes.DELETE_SCREEN_SUCCESS;
  screenId: string;
}

export interface IAddScreen {
  type: actionTypes.ADD_SCREEN;
  payload: any;
}

export interface IAddScreenSuccess {
  type: actionTypes.ADD_SCREEN_SUCCESS;
  payload: any;
}

export interface IUpdateScreen {
  type: actionTypes.UPDATE_SCREEN;
  payload: any;
}

export interface IUpdateScreenSuccess {
  type: actionTypes.UPDATE_SCREEN_SUCCESS;
  payload: any;
}

export interface IUpdateSelectedScreen {
  type: actionTypes.UPDATE_SELECTED_SCREEN;
  screenId: string;
  isFetchAssets: boolean;
}

export interface IUpdateSelectedScreenSuccess {
  type: actionTypes.UPDATE_SELECTED_SCREEN_SUCCESS;
  screenId: string;
}

export const fetchScreensPending = (): IFetchScreenPending => {
  return { type: actionTypes.FETCH_SCREENS_PENDING };
};
export const fetchScreens = (userId): IFetchScreens => {
  return {
    type: actionTypes.FETCH_SCREENS,
    userId
  };
};

export const fetchScreensSuccess = (payload: any): IFetchScreenSuccess => {
  return {
    type: actionTypes.FETCH_SCREENS_SUCCESS,
    payload
  };
};

export const deleteScreenSuccess = (screenId: string): IDeleteScreenSuccess => {
  return {
    type: actionTypes.DELETE_SCREEN_SUCCESS,
    screenId
  };
};

export const addScreenSuccess = (payload: any): IAddScreenSuccess => {
  return {
    type: actionTypes.ADD_SCREEN_SUCCESS,
    payload
  };
};

export const updateScreenSuccess = (payload: any): IUpdateScreenSuccess => {
  return {
    type: actionTypes.UPDATE_SCREEN_SUCCESS,
    payload
  };
};

export const deleteScreen = (screenId: string): IDeleteScreen => {
  return {
    type: actionTypes.DELETE_SCREEN,
    screenId
  };
};

export const addScreen = (payload: any): IAddScreen => {
  return {
    type: actionTypes.ADD_SCREEN,
    payload
  };
};

export const updateScreen = (payload: any): IUpdateScreen => {
  return {
    type: actionTypes.UPDATE_SCREEN,
    payload
  };
};

export const updateSelectedScreen = (
  screenId: any,
  isFetchAssets: boolean
): IUpdateSelectedScreen => {
  return {
    type: actionTypes.UPDATE_SELECTED_SCREEN,
    screenId,
    isFetchAssets
  };
};
export const updateSelectedScreenSuccess = (
  screenId: any
): IUpdateSelectedScreenSuccess => {
  return {
    type: actionTypes.UPDATE_SELECTED_SCREEN_SUCCESS,
    screenId
  };
};

export type IScreenAction =
  | IFetchScreenSuccess
  | IFetchScreenPending
  | IDeleteScreenSuccess
  | IAddScreenSuccess
  | IUpdateScreenSuccess
  | IUpdateSelectedScreen
  | IDeleteScreen
  | IAddScreen
  | IUpdateScreen;
